module.exports = __webpack_public_path__ + "axios-wordmark-cbd7dba47cd221e47a2d0760139e2858.webp";